module.exports = __webpack_public_path__ + "static/img/home-hero-tablet-bg-04.2833ab7.png";